import script from "./CustomDataFieldPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDataFieldPicker.vue?vue&type=script&setup=true&lang=js"

import "./CustomDataFieldPicker.vue?vue&type=style&index=0&id=4fc17828&scoped=true&lang=scss"
import "./CustomDataFieldPicker.vue?vue&type=style&index=1&id=4fc17828&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fc17828"]])

export default __exports__